import { logAndylitics, log, logAPI } from "./andyliticsApi";

const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : ''; // window is undefined during pre-render
const myBswHealthBffBaseUrl = typeof window !== 'undefined' ? window.serverData.data.thriveApiBaseUrl : '';
const functionsKey = typeof window !== 'undefined' ? window.serverData.data.thriveFunctionsKey : '';
const surveyRequestUrl = typeof window !== 'undefined' ? window.serverData.data.surveyUrl : '';
const instaDocBFFBaseUrl = typeof window !== 'undefined' ? window.serverData.data.instaDocBFFBaseUrl : ''; 
const instaDocBFFXFunctionsKey = typeof window !== 'undefined' ? window.serverData.data.instaDocBFFXFunctionsKey : '';

/**
 * Returns dashboard data for the given login id.
 * 
 * @param {any} loginId loginId of the logged-in user.
 * @param {any} token user's auth token.
 * @param {any} proxyId user's proxy ID.
 * @returns {any} epic dashboard data.
 */
export const getEpicDashboardData = (loginId, token, proxyId) => {
    const proxyIdParam = proxyId ? '&proxyPatientId=' + proxyId + '&proxyPatientIdType=External' : "";
    const url = `${apiBaseUrl}v2/epic/GetEpicDashboardData?loginId=${encodeURIComponent(loginId)}${proxyIdParam}`;
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("Api.Dashboard.GetEpicData", start, url);
        return response;
    }).catch(err => { logAPI("Api.Dashboard.GetEpicData.Failure", start, url, err); return Promise.reject(err);});
};

/**
 * the mybswhealth bff's v2/dashboard contains video visit appointment details; the epic dashboard call above does not.
 * 
 * @param {any} token user's auth token
 * @returns {any} dashboard data from the new bff.
 */
export const getDashboardV2 = (token) => {
    const url = `${myBswHealthBffBaseUrl}v2/dashboard`;

    const params = {
        headers: {
            "x-functions-key": functionsKey,
            "content-type": "application/json",
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };
    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("Api.Dashboard.BFFV2Dashboard", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("Api.Dashboard.BFFV2Dashboard.Failure", start, url, err);
            return Promise.reject(err);
        });

};

export const ambulatorySurveyRequest = (token, surveyRequest) => {
    const url = `${surveyRequestUrl}api/SurveyQuestionResponse`;
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json",
        },
        body: JSON.stringify(surveyRequest.data),
        method: "POST"
    };
    const start = new Date();
    return fetch(url, params)
        .then(resp => {
            logAPI("Api.AmbulatorySurvey.Success", start, url);
            if (resp && resp.status === 200) return resp.status;
            else {
                return Promise.reject(resp);
            }
        })
        .catch(err => {
            logAPI("Api.AmbulatorySurvey.Failure", start, url, err);
            return Promise.reject(err);
        });
};

export const getEpicDepartmentList = (token) => {
    const fullUrl = `${instaDocBFFBaseUrl}/api/v1/departments`;

    const params = {
        headers: {
            "authorization": "bearer " + token,
            "Accept": "application/json",
            "Content-type": "application/json",
            "Cache-Control": "no-cache",
            "Pragma": "no-cache",
            "x-functions-key": instaDocBFFXFunctionsKey,
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(fullUrl, params).then(response => {
        logAPI("Api.Portal.EpicDepartmentList.Get", start, fullUrl);
        return response.json();
    }).catch(err => {
        logAPI("Api.Portal.EpicDepartmentList.Get.Failure", start, fullUrl);
        return Promise.reject(err);
    });
};